import { React, classNames } from '@digsup/core-ui';
import PropTypes from 'prop-types';
import { InView } from 'react-intersection-observer';
import { Content } from './Content';
import { Lab } from './Lab';
import { styles } from './Hero.scss';

const cx = classNames.bind(styles);

// eslint-disable-next-line arrow-body-style
export const Hero = ({ children }) => {
  return (
    <InView>
      {({ inView, ref }) => (
        <div
          className={cx('l-homepage-hero', {
            'l-homepage-hero--out-of-view': !inView,
          })}
          ref={ref}
          id="hero">
          <Content>{children}</Content>
          <Lab />
        </div>
      )}
    </InView>
  );
};

Hero.propTypes = {
  children: PropTypes.any,
  /**
   * Adress search callback
   */
  onSearch: PropTypes.func,
};
